import { Toaster as Sonner, toast } from "sonner"

// Brand-aligned dark theme matching the rest of the app shell.
// Sonner is rendered inside Tailwind's dark scope via App.js, so we map the
// classes to the same design tokens (background, foreground, border, teal)
// every other surface uses.
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:shadow-xl group-[.toaster]:rounded-2xl group-[.toaster]:font-body",
          title: "group-[.toast]:font-body group-[.toast]:font-semibold group-[.toast]:text-sm",
          description: "group-[.toast]:text-foreground/70 group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-teal group-[.toast]:text-white group-[.toast]:rounded-full group-[.toast]:font-body group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-foreground/70 group-[.toast]:rounded-full",
          success:
            "group-[.toaster]:border-teal/40",
          error:
            "group-[.toaster]:border-red-500/50",
          warning:
            "group-[.toaster]:border-gold/50",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast }
